import React  from 'react';
import "./LogoForm.scss";
interface PropsLogoForm{
        logobase64:string
}



export const LogoForm: React.FC<PropsLogoForm> = (props) => {


    return <>
            {
                props.logobase64  ? 
                <div className="col-md-12 d-flex justify-content-center align-items-center">
                <div className="logo-form">
                    <img  src={props.logobase64} alt=""/>
                </div>
            </div> : <></>
            }
    </>
}